export const SDK_SET_BUBBLE_VISIBILITY = 'sdk-set-bubble-visibility';

// Carries an end-user access token from the host page to the widget. Unlike every
// other command it is origin-pinned on send and origin-checked on receive — see
// IFrameHelper.sendMessageToWidgetOrigin.
export const SDK_SET_AUTH_TOKEN = 'set-auth-token';
